export const getEventNameRaceProps = (selection, state) => {
    const startDateTime = state.formatTime(selection.startEventDate, 0);
    return {
        sportName: selection.sportName,
        leagueName: `${startDateTime} ${selection.leagueName}`
    };
};
//# sourceMappingURL=getEventNameRaceProps.js.map